import makeStyles from '@mui/styles/makeStyles';
import TextField from '@mui/material/TextField';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import {map, noop} from 'lodash';
import React from "react";


const useOutlinedInputStyles = makeStyles(theme => {
  return (
    {
      root: {
        backgroundColor: 'white',
        boxShadow: '0px 0px 2px rgba(0, 0, 0, 0.1) inset',
        "&:hover:not($disabled):not($focused):not($error) $notchedOutline": {}
      },
      notchedOutline: {
        border: '0px !important',
      },
    })
});

const DateTimeSelection = ({onAnswered = noop(), value = null}) => {
  const classes = useOutlinedInputStyles();
  const handleDateChange = date => {
    onAnswered(date);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DateTimePicker
        inputFormat="DD/MM/YYYY hh:mm A"
        dayOfWeekFormatter={day => day}
        value={value}
        onChange={handleDateChange}
        OpenPickerButtonProps={{
          'aria-label': 'Select Date Time',
        }}
        renderInput={params => (
          <TextField
            {...params}
            id="date-picker-dialog"
            fullWidth
            variant="outlined"
            inputProps={{...params.inputProps, placeholder: "DD/MM/YYYY hh:mm AM"}}
            InputProps={{
              ...params.InputProps,
              classes: {
                root: classes.root, notchedOutline: classes.notchedOutline
              }
            }}
          />
        )}
      />
    </LocalizationProvider>
  );
};


export default (DateTimeSelection);
